export default (function (accountsUrl) {
  return window.location.replace("".concat(accountsUrl, "/login?redirect=").concat(window.location));
});